import type { AccessibleRegion } from '../auth/permissions';
import type { Currency, Market, PlusMarketingState } from '../dataProvider';

/**
 * Admin-side helpers for the Settings surface (D-settings-s1, Phase 9 S1). The
 * singleton-config surface is region-keyed (ONE ROW PER MARKET), so the surface
 * maps between the uppercase access scope (UK / US / GLOBAL) and the lowercase data
 * market the config rows carry, the one mapping already used across the app.
 */

/** The Plus marketing staged-activation states, in lifecycle order. */
export const PLUS_MARKETING_STATES: readonly PlusMarketingState[] = [
  'dormant',
  'partial',
  'active',
];

/** Display label for a Plus marketing state. */
export const PLUS_MARKETING_LABEL: Record<PlusMarketingState, string> = {
  dormant: 'Dormant (off)',
  partial: 'Partial (beta cohort)',
  active: 'Active (live)',
};

/** Display label for a market's settlement / display currency. */
export const CURRENCY_LABEL: Record<Currency, string> = {
  gbp: 'GBP (£)',
  usd: 'USD ($)',
  eur: 'EUR (€)',
};

/** A concrete data market (lowercase) as its access-scope region (uppercase). */
export const marketToRegion = (market: Market): AccessibleRegion =>
  market === 'us' ? 'US' : 'UK';

/** The active access region (uppercase) as its data market (lowercase). */
export const regionToMarket = (region: AccessibleRegion): Market =>
  region === 'US' ? 'us' : 'uk';
